import { render, staticRenderFns } from "./ConsentDataDescription.vue?vue&type=template&id=3f34c360&scoped=true&"
import script from "./ConsentDataDescription.vue?vue&type=script&lang=ts&"
export * from "./ConsentDataDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f34c360",
  null
  
)

export default component.exports